import { TIMELINE_STEPS, reachedStep } from '../utils/phase';

// Horizontal status timeline: completed steps green, pending gray. When `onStep`
// is provided, each step within reach (index ≤ reached+1) becomes a clickable
// action — you can revisit a done step or advance to the immediate next, but not
// skip ahead. Forward-locked steps are non-interactive.

export default function SessionTimeline({ item, onStep }) {
    const reached = reachedStep(item);

    return (
        <ol className="opu-timeline" aria-label="Avance del flujo">
            {TIMELINE_STEPS.map((s, i) => {
                const done = i <= reached;
                const actionable = !!onStep && i <= reached + 1;
                const inner = (
                    <>
                        <span className="opu-timeline__dot">
                            {done && (
                                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M20 6 9 17l-5-5" />
                                </svg>
                            )}
                        </span>
                        <span className="opu-timeline__label">{s.label}</span>
                    </>
                );
                return (
                    <li
                        key={s.key}
                        className={`opu-timeline__step ${done ? 'opu-timeline__step--done' : 'opu-timeline__step--pending'} ${actionable ? 'opu-timeline__step--action' : ''}`}
                    >
                        {actionable ? (
                            <button type="button" className="opu-timeline__btn" onClick={() => onStep(s.key)} title={`${s.label} →`}>
                                {inner}
                            </button>
                        ) : (
                            <div className="opu-timeline__btn" title={`${s.label}: ${done ? 'completado' : 'pendiente'}`}>
                                {inner}
                            </div>
                        )}
                    </li>
                );
            })}
        </ol>
    );
}
